import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { BottomSheet } from "@ui-kit/BottomSheet/BottomSheet";
import { LinkButton } from "@ui-kit/LinkButton/LinkButton";
import { useBottomSheet } from "@ui-kit/BottomSheet/BottomSheetContext";
import { EntityList } from "@modules/entityList/EntityList/EntityList";
import { useTranslation } from "react-i18next";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { useMatch, useSearchParams } from "react-router";
import { MapOverlayButton } from "@modules/components/buttons/MapOverButton/MapOverlayButton";
import { useEffect } from "react";

import "./EntityListBottomSheet.css";

/**
 * Entity list bottom sheet. Responsible for showing listings on mobile.
 */
const EntityListBottomSheet = () => {
  const { isMobile } = useWindowSize();

  if (!isMobile) {
    return null;
  }

  return (
    <BottomSheet
      expandButton={<ExpandButton />}
      collapseButton={<CollapseButton />}>
      <EntityListBottomSheetInner />
    </BottomSheet>
  );
};

export const ExpandButton = () => {
  const { expand } = useBottomSheet();
  const { t } = useTranslation();
  return (
    <div className="entity-list-bottom-sheet-expand-button">
      <LinkButton onPress={expand} size="large" color={colors.blue400}>
        {t("lists.showList")}
      </LinkButton>
    </div>
  );
};

const CollapseButton = () => {
  const { collapse } = useBottomSheet();
  return (
    <div className="entity-list-bottom-sheet-collapse-button">
      <MapOverlayButton onPress={collapse} />
    </div>
  );
};

const EntityListBottomSheetInner = () => {
  const isPlanScreen = useMatch("/plan");
  const [searchParams] = useSearchParams();
  const isMobileMapView = searchParams.get("view") === "map";
  const { close, open } = useBottomSheet();

  useEffect(() => {
    if (isPlanScreen || isMobileMapView) {
      close();
    } else {
      open();
    }
  }, [isPlanScreen, isMobileMapView, close, open]);

  return (
    <div className="entity-list-bottom-sheet-inner">
      <EntityList />
    </div>
  );
};

export { EntityListBottomSheet };
